import { FC } from 'react';

import { Icon, RyeconWarningOutline } from '@dbt-labs/sourdough';

import { safeParseUniqueId } from '@/typings/parseUniqueId';
import { capitalizedResourceNames } from '@/util/resourceType';

type ResourceDoesNotExistParams = {
  uniqueId: string;
};

export const ResourceDoesNotExist: FC<ResourceDoesNotExistParams> = ({ uniqueId }) => {
  const parsedUniqueId = safeParseUniqueId(uniqueId).ok;
  const resourceType = parsedUniqueId?.resourceType
    ? capitalizedResourceNames[parsedUniqueId.resourceType]?.toLocaleLowerCase()
    : 'resource';
  const errorMessage =
    resourceType !== 'resource'
      ? `The ${resourceType} "${parsedUniqueId?.remainder}" does not exist in this environment.`
      : `The resource "${uniqueId}" does not exist in this environment.`;
  return (
    <div className="mx-auto w-6/12">
      <div className="mt-[30%] text-center">
        <div className={`m-auto flex h-[56px] w-[56px] rounded-md`}>
          <Icon size="lg" ryecon={RyeconWarningOutline} />
        </div>
        <div className="mt-4 break-words">
          <h1 className="mb-2 text-2xl font-medium">{errorMessage}</h1>
          <span className="text-base font-normal">
            Please ensure that this {resourceType} has been committed to the project and
            run in a job within this environment.
          </span>
        </div>
      </div>
    </div>
  );
};
